
export function projectTablePrefName(input: string, project: number) {
    return input + "." + project;
}